import React from "react";
import { MenuItem } from "@mui/material";
import { translate } from "../../../providers";
import { CustomTooltip } from "../../tooltip";
import styles from "./Selector.module.css";
import { getFilteredDataAttributes } from "../../../utils";
import CustomSelect from "../custom-select/CustomSelect";

const SIZE_MAP = { small: "sm", medium: "md", sm: "sm", md: "md" };

export default function Selector({
	autoTranslate = "yes",
	className = "",
	disabled = false,
	error = false,
	extraField = "",
	field = null,
	fallbackField = field,
	fullWidth = false,
	helperText = "",
	itemRenderer = (itemLabel) => itemLabel,
	items,
	label,
	labelClassName = "",
	listClassName = "",
	menuClassName = "",
	onChange,
	required = false,
	size = "md",
	textFieldClassName = "",
	value,
	valueRenderer = null,
	withNone = false,
	placeholder = "",
	...dataAttributes
}) {
	const filteredDataAttributes = getFilteredDataAttributes(dataAttributes);
	const handleChange = (e) => {
		e.stopPropagation();
		if ((!e.target?.value && !withNone) || e.target.value?.disabled) {
			return;
		}
		onChange(e);
	};
	return (
		<div className={`${styles.container} ${fullWidth ? styles["container--fullWidth"] : ""}`}>
			{label && (
				<div className={`${styles.label} ${labelClassName}`}>
					{label}
					{required && <span className={styles.required}>*</span>}
				</div>
			)}
			<CustomSelect
				className={`${styles.textField} ${className}`}
				disabled={disabled}
				displayEmpty={!!placeholder}
				error={error}
				fullWidth={fullWidth}
				InputProps={{ className: textFieldClassName }}
				MenuProps={{ classes: { list: listClassName, root: menuClassName } }}
				renderValue={(selected) => {
					if (
						selected === "" ||
						selected == null ||
						(typeof selected === "object" && Object.keys(selected).length === 0)
					) {
						return <span className={styles.placeholder}>{translate(placeholder) || placeholder}</span>;
					}
					return (
						(valueRenderer && valueRenderer(selected)) ||
						(field && selected?.[field]) ||
						selected?.[fallbackField] ||
						selected
					);
				}}
				required={required}
				size={SIZE_MAP[size] || "md"}
				translate={autoTranslate}
				value={value}
				onChange={handleChange}
				onClose={() =>
					setTimeout(() => {
						document.activeElement.blur();
					}, 0)
				}
			>
				{withNone ? (
					<MenuItem value="">
						<div className={styles.textfield__item}>{translate("common:empty-state.none")}</div>
					</MenuItem>
				) : null}
				{Array.isArray(items) &&
					items.map((item) => {
						const key = item?.[field] || item?.[fallbackField] || item;
						const keyItem = item?.id;
						const extra = extraField && item?.[extraField] ? ` (${item[extraField]})` : "";
						return (
							<MenuItem
								key={keyItem || key}
								disabled={item.disabled || item.locked || (item.active !== undefined && !item.active)}
								value={item}
								{...filteredDataAttributes}
							>
								<CustomTooltip title={item.tooltip || ""}>
									<div
										className={styles.textfield__item}
										data-disabled={item.disabled}
										translate={autoTranslate}
									>
										{itemRenderer(`${key}${extra}`, item)}
									</div>
								</CustomTooltip>
							</MenuItem>
						);
					})}
			</CustomSelect>
			{helperText && (
				<span className={`${styles.helperText} ${error ? styles["helperText--error"] : ""}`}>{helperText}</span>
			)}
		</div>
	);
}
